@if (toasts().length > 0) {
  <div class="toast-host" [attr.aria-live]="ariaLive()" aria-atomic="false">
    @for (toast of toasts(); track toast.id; let index = $index) {
      <modus-wc-toast
        class="app-toast"
        position="bottom-center"
        customClass="app-toast-item"
        [style.transform]="stackOffset(index)"
      >
        <modus-wc-alert
          [attr.variant]="alertVariant(toast.type)"
          [attr.alert-title]="toast.title || null"
          [attr.alert-description]="toast.message"
          dismissible="false"
        ></modus-wc-alert>
      </modus-wc-toast>
    }
  </div>
}
